import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';

export default function Loader() {
  const [progress, setProgress] = useState(0);

  /* Smooth progress to 100 over ~1100ms */
  useEffect(() => {
    const start = performance.now();
    const duration = 1100;

    const tick = (now) => {
      const elapsed = now - start;
      const p = Math.min(Math.round((elapsed / duration) * 100), 100);
      setProgress(p);
      if (p < 100) requestAnimationFrame(tick);
    };

    const id = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(id);
  }, []);

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      sx={{
        background: '#f4f3ef',
        overflow: 'hidden',
        position: 'relative',
      }}
    >
      {/* Drafting grid — same as Home */}
      <div style={{
        position: 'absolute', inset: 0, pointerEvents: 'none',
        backgroundImage: `
          linear-gradient(rgba(26,48,80,0.055) 1px, transparent 1px),
          linear-gradient(90deg, rgba(26,48,80,0.055) 1px, transparent 1px)
        `,
        backgroundSize: '28px 28px',
        WebkitMaskImage: 'radial-gradient(ellipse 70% 70% at 50% 50%, black 30%, transparent 100%)',
        maskImage:       'radial-gradient(ellipse 70% 70% at 50% 50%, black 30%, transparent 100%)',
      }} />

      {/* Main content */}
      <div style={{
        position: 'relative', zIndex: 1,
        display: 'flex', flexDirection: 'column',
        alignItems: 'center', gap: 0,
        animation: 'fadeIn 0.4s ease both',
      }}>

        {/* Precision mark */}
        <svg
          width="52" height="52"
          viewBox="0 0 52 52"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ marginBottom: '1.75rem' }}
        >
          {/* Outer hairline circle */}
          <circle cx="26" cy="26" r="24" stroke="#1a3050" strokeWidth="0.75" strokeOpacity="0.22" />
          {/* Arc — top-left quadrant */}
          <path d="M 26 2 A 24 24 0 0 1 50 26"
            stroke="#1a3050" strokeWidth="1" strokeOpacity="0.55" strokeLinecap="round" />
          {/* Arc — bottom-right quadrant */}
          <path d="M 26 50 A 24 24 0 0 1 2 26"
            stroke="#1a3050" strokeWidth="1" strokeOpacity="0.55" strokeLinecap="round" />
          {/* Cardinal tick marks */}
          <line x1="26" y1="2"  x2="26" y2="8"  stroke="#1a3050" strokeWidth="1.2" strokeOpacity="0.5" />
          <line x1="26" y1="44" x2="26" y2="50" stroke="#1a3050" strokeWidth="1.2" strokeOpacity="0.5" />
          <line x1="2"  y1="26" x2="8"  y2="26" stroke="#1a3050" strokeWidth="1.2" strokeOpacity="0.5" />
          <line x1="44" y1="26" x2="50" y2="26" stroke="#1a3050" strokeWidth="1.2" strokeOpacity="0.5" />
          {/* Centre dot */}
          <circle cx="26" cy="26" r="2.5" fill="#457b9d" fillOpacity="0.8" />
        </svg>

        {/* Name */}
        <span style={{
          fontFamily: "'Cormorant Garamond', Georgia, serif",
          fontSize: '1.65rem',
          fontWeight: 700,
          color: '#1a3050',
          letterSpacing: '0.01em',
          lineHeight: 1,
          marginBottom: '0.35rem',
        }}>
          Madhu Vanguri
        </span>

        {/* Role */}
        <span style={{
          fontFamily: "'IBM Plex Mono', monospace",
          fontSize: '0.6rem',
          fontWeight: 400,
          color: '#7a8499',
          letterSpacing: '0.18em',
          textTransform: 'uppercase',
          marginBottom: '2rem',
        }}>
          Mechanical Design Engineer
        </span>

        {/* Progress bar */}
        <div style={{ width: 200 }}>
          <div style={{
            height: 1,
            background: 'rgba(26,48,80,0.1)',
            borderRadius: 1,
            overflow: 'hidden',
          }}>
            <div style={{
              height: '100%',
              width: `${progress}%`,
              background: 'linear-gradient(90deg, #457b9d, #1a3050)',
              borderRadius: 1,
              transition: 'width 0.06s linear',
            }} />
          </div>
        </div>

      </div>

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(8px); }
          to   { opacity: 1; transform: translateY(0);   }
        }
      `}</style>
    </Box>
  );
}